import React from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from 'tss-react/mui';
import NavDetails from "components/Elements/NavDetails";
import { appPath, newAnalyticsPath } from "helpers/routePaths";
import TabTitle from "components/Elements/TabTitle";
import { ReportProvider } from './ReportContext';
import { ReportHeader } from './Layout';
import { ReportContent } from './ReportChart';

const useStyles = makeStyles()((theme) => ({
  header: {
    marginTop: '35px'
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
}));

const ReportPage = ({ title, chartConfig, customCrumbs = [], hideNav = false }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  // Default crumbs with Analytics as the first item
  const defaultCrumbs = [
    { id: 1, name: t("title.analytics"), url: appPath + newAnalyticsPath },
  ];

  // If customCrumbs is provided, add it to the default crumbs
  // Otherwise, add the title as the second crumb
  const staticCrumbs = customCrumbs.length > 0
    ? [...defaultCrumbs, ...customCrumbs]
    : [...defaultCrumbs, { id: 2, name: title }];

  return (
    <>
      <TabTitle title={title} />
      <ReportProvider config={chartConfig}>
        <div className="topContainerCustomCaptions">
          {!hideNav && (
            <NavDetails
              history={false}
              status={false}
              staticCrumbs={staticCrumbs}
            />
          )}
          <ReportHeader />
        </div>

        <div className={classes.header}>
          <ReportContent />
        </div>
      </ReportProvider>
    </>
  );
};

export default ReportPage; 